module.exports = __webpack_public_path__ + "static/media/flexline_logo_se.dbcef23a.png";